<script setup>
import { computed } from 'vue'

const props = defineProps({
  items: { type: Array, required: true },
  reverse: { type: Boolean, default: false },
  duration: { type: Number, default: 60 },
})
// The list is rendered twice so the track can loop seamlessly by shifting exactly half its width.
const loop = computed(() => [...props.items, ...props.items])
</script>

<template>
  <div class="picture-marquee" :class="{ 'is-reverse': reverse }" :style="{ '--marquee-duration': `${duration}s` }">
    <div class="picture-marquee-track">
      <figure v-for="(item, index) in loop" :key="index" :aria-hidden="index >= items.length ? 'true' : undefined">
        <img :src="item.src" :alt="item.alt" loading="lazy" />
        <figcaption v-if="item.label">{{ item.label }}</figcaption>
      </figure>
    </div>
  </div>
</template>
